import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { RocheUIDiagnosticsHeader as c } from "../diagnostics-header/roche-diagnostics-header.js";
import { RocheUIDiagnosticsItem as m } from "../diagnostics-item/roche-diagnostics-item.js";
import { RocheUIPipelineRowGroupSection as n } from "../pipeline-row-group-section/roche-pipeline-row-group-section.js";
const d = ({ groups: o, headlineLevel: r, ...t }) => /* @__PURE__ */ a("div", { children: [
  /* @__PURE__ */ i(c, { ...t }),
  o.map((e) => /* @__PURE__ */ i(
    n,
    {
      group: e,
      triggerLabel: e.label,
      headlineLevel: r,
      initiallyOpen: !0,
      hasTightGap: !0,
      rowRenderer: (s) => /* @__PURE__ */ i(m, { ...s })
    },
    e.id
  ))
] });
export {
  d as RocheUIDiagnostics
};
